import RecentlyPerfomedSignings from './recently-performed-signings-view'

export default RecentlyPerfomedSignings
